import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import baseTheme from '@elementary/common-ui/style/theme';
import { Box } from '@mui/material';

const getCoverageProperties = (value: number) => {
  if (value === 0) {
    return {
      color: baseTheme.palette.common.red2,
      barCount: 0,
    };
  }
  if (value <= 25) {
    return {
      color: baseTheme.palette.common.red2,
      barCount: 1,
    };
  }
  if (value <= 50) {
    return {
      color: baseTheme.palette.common.orange2,
      barCount: 2,
    };
  }
  if (value <= 75) {
    return {
      color: baseTheme.palette.common.yellow,
      barCount: 3,
    };
  }
  return {
    color: baseTheme.palette.common.green100,
    barCount: 4,
  };
};

const Bar = styled(Box)<{
  $color?: string;
  $size: 'small' | 'large';
  $active?: boolean;
}>`
  width: ${({ $size }) => ($size === 'small' ? 14 : 20)}px;
  height: ${({ $size }) => ($size === 'small' ? 2.5 : 3.5)}px;
  border-radius: ${({ $size }) => ($size === 'small' ? 1 : 1.5)}px;
  background: ${({ theme, $color }) => $color || theme.palette.common.gray17};
  box-shadow: ${({ $active, theme }) =>
    $active
      ? 'none'
      : `0.75px 1.5px 4.425px 0px inset ${theme.palette.common.gray17}`};
`;

const BarsWrapper = styled(FlexColumn)<{ $size: 'small' | 'large' }>`
  align-items: center;
  justify-content: center;
  gap: ${({ $size }) => ($size === 'small' ? 1.5 : 2.5)}px;
`;

const BarStack = ({
  value,
  size = 'small',
}: {
  value: number;
  size?: 'small' | 'large';
}) => {
  const { color, barCount } = getCoverageProperties(value);
  const emptyBars = 4 - barCount;

  return (
    <BarsWrapper $size={size}>
      {Array(emptyBars)
        .fill(null)
        .map((_, i) => (
          <Bar key={`empty-${i}`} $size={size} $active={false} />
        ))}
      {Array(barCount)
        .fill(null)
        .map((_, i) => (
          <Bar key={`colored-${i}`} $color={color} $size={size} $active />
        ))}
    </BarsWrapper>
  );
};

export default BarStack;
